/**
 * removeQuizQuestion.js
 * Written by: Brian Kim
 */
import selectedQuizRaw from '../../selectors/selectedQuiz';
import nextQuestionRaw from '../../../question/selectors/nextQuestion';
import { selectNextQuestion } from '../../../question/actions/selectNextQuestion';

export const REMOVE_QUIZ_QUESTION_START = `REMOVE_QUIZ_QUESTION_START`;
export const REMOVE_QUIZ_QUESTION_SUCCESS = `REMOVE_QUIZ_QUESTION_SUCCESS`;
export const REMOVE_QUIZ_QUESTION_FAILURE = `REMOVE_QUIZ_QUESTION_FAILURE`;

export const removeQuizQuestionStart = () => ({
  type: REMOVE_QUIZ_QUESTION_START,
});

export const removeQuizQuestionSuccess = (quiz) => ({
  type: REMOVE_QUIZ_QUESTION_SUCCESS,
  quiz,
});

export const removeQuizQuestionFailure = (error) => ({
  type: REMOVE_QUIZ_QUESTION_FAILURE,
  error,
});

/**
 *  Remove question from the currently selected quiz
 */
export const removeQuizQuestion = (questionId) => {
  return (dispatch, getState) => {
    dispatch(removeQuizQuestionStart());
    try {
      const nextQuestion = nextQuestionRaw(getState());
      const selectedQuiz = selectedQuizRaw(getState());
      const quizQuestionIdx = selectedQuiz.questions.indexOf(questionId);
      if (quizQuestionIdx !== -1) {
        selectedQuiz.questions.splice(quizQuestionIdx, 1);
        if (!nextQuestion || nextQuestion === questionId) dispatch(selectNextQuestion(questionId));
      }
      dispatch(removeQuizQuestionSuccess(selectedQuiz));
    } catch (error) {
      dispatch(removeQuizQuestionFailure(error));
    }
  };
};

export default removeQuizQuestion;
